"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Loader = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _propTypes = _interopRequireDefault(require("prop-types"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var StyledOverlay = /*#__PURE__*/_styledComponents["default"].div.withConfig({
  componentId: "kds-v1__sc-1uew3mm-0"
})(["display:flex;align-items:center;justify-content:center;backdrop-filter:blur(3px);position:fixed;top:0;bottom:0;left:0;right:0;z-index:1;background-color:rgba(0,0,0,.2);"]);
var LoaderImage = /*#__PURE__*/_styledComponents["default"].img.withConfig({
  componentId: "kds-v1__sc-1uew3mm-1"
})(["height:340px;"]);
var Loader = exports.Loader = function Loader(_ref) {
  var isOpen = _ref.isOpen,
    src = _ref.src;
  if (!isOpen) {
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null);
  }
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(StyledOverlay, null, /*#__PURE__*/_react["default"].createElement(LoaderImage, {
    src: src,
    alt: "Loading..."
  })));
};
Loader.propTypes = {
  isOpen: _propTypes["default"].bool,
  src: _propTypes["default"].string.isRequired
};
Loader.defaultProps = {
  isOpen: false
};